import React from "react";
import Icon from "../../assets/icons.png";
import AppleIco from "../../assets/apstore.png";
import PlayStore from "../../assets/playstore.png";
import { Link } from "react-router-dom";

const GetApp = () => {
  return (
    <div>
      {
        // section three
        <section
          style={{ position: "relative", top: "4em" }}
          className="mt-5"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container">
            <div className="row bg-sec3" style={{ padding: "4em" }}>
              <div className="col-md-6 ">
                <div className="text-center">
                  <span className="barlow600" style={{ fontSize: "3.5em" }}>
                    Get Nuprex App
                  </span>{" "}
                  <br />
                  <span
                    className="barlow600"
                    style={{
                      fontSize: "3.5em",
                      position: "relative",
                      bottom: "0.5em",
                    }}
                  >
                    at you finger tips
                  </span>
                </div>
                <p className="barlow200 text-center">
                  You can easily send and receive packages around Lagos with our
                  Nuprex Application.
                </p>

                <div className="text-center ">
                  <Link
                    to="https://apps.apple.com/ng/app/nuprex-delivery-run-errands/id6738646035"
                    target="_blank"
                  >
                    <img width={150} src={AppleIco} alt="apple icon" />{" "}
                  </Link>
                  &nbsp;&nbsp; &nbsp;{" "}
                  <Link
                    target="_black"
                    to="https://play.google.com/store/apps/details?id=com.nuprex.nuprexCustomerApplication&hl=en"
                  >
                    <img width={150} src={PlayStore} alt="apple icon" />
                  </Link>
                </div>
              </div>
              <div className="col-md-6">
                <div className="image-container">
                  <img
                    className="hand-icon cursor-pointer"
                    src={Icon}
                    alt="picss"
                    style={{ width: "50vw", height: "auto" }} // 50% of the viewport width
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </div>
  );
};

export default GetApp;
